module.exports = __webpack_public_path__ + "static/media/conejomama_tex.e9b71bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/conejo_mama/conejomama_tex.png
// module id = 151
// module chunks = 0